import { render } from "./TPCommonInput.vue?vue&type=template&id=62daeb8c&scoped=true&ts=true"
import script from "./TPCommonInput.vue?vue&type=script&lang=ts"
export * from "./TPCommonInput.vue?vue&type=script&lang=ts"

import "./TPCommonInput.vue?vue&type=style&index=0&id=62daeb8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62daeb8c"]])

export default __exports__